import moment from "moment-timezone";
import { message as antdMessage } from "antd";
import metaData from "../data/metaData";
import { diff as fullDiff } from "deep-object-diff";
import _ from "lodash";
import { formatTime } from "./time";
import bcrypt from "bcryptjs";

const getBookOptionList = (arr) => {
  let inStore = {};
  //console.log(arr);
  let delivery = {};

  for (let e of arr) {
    if (e.orderType == "IN_STORE_REDEEM") {
      let options = e.ticket[0].options;

      for (let i = 0; i < options.length; i++) {
        let item;
        let option = options[i];
        item = inStore[option.name] || {
          name: option.name,
          lotName: e.ticket[0].lotName,
          photoPath: option.photoPath,
          count: 0,
        };
        item.count += option.qty;
        //console.log(item)
        inStore[option.name] = item;
      }
    } else if (e.orderType == "DELIVERY_REDEEM") {
      let options = e.ticket[0].options;

      for (let i = 0; i < options.length; i++) {
        let item;
        let option = options[i];
        item = delivery[option.name] || {
          name: option.name,
          lotName: e.ticket[0].lotName,
          photoPath: option.photoPath,
          count: 0,
        };
        item.count += option.qty;
        //console.log(item)
        delivery[option.name] = item;
      }
    }
    // } else if (e.orderType == "DELIVERY_REDEEM") {
    //   let address = e.ticket[0].address;

    //   for (let i = 0; i < address.length; i++) {
    //     let item = delivery[address[i].address] || {
    //       address: address[i].address,
    //       lotName: e.ticket[0].lotName,
    //       options: [],
    //     };
    //     let options = address[i].options;

    //     for (let y = 0; y < options.length; y++) {
    //       let option = options[y];
    //       let opt = item.options[option.name] || {
    //         name: option.name,
    //         photoPath: option.photoPath,
    //         count: 0,
    //       };
    //       opt.count += option.qty;
    //       item.options[option.name] = opt;
    //     }

    //     //convert item.options from obj to arr
    //     item.options = Object.values(item.options);

    //     delivery[address[i].address] = item;
    //   }
    // }
  }

  // console.log(inStore);
  // console.log(delivery);
  inStore = Object.values(inStore);
  delivery = Object.values(delivery);
  // console.log(inStore);
  // console.log(delivery);

  return { inStore, delivery };
};

const displayReadId = (str) => {
  var parts = str.match(/.{1,5}/g);
  return parts.join("-"); //returns 123-456-789
};

function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

function getMobileOperatingSystem() {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;

  if (/windows phone/i.test(userAgent)) {
    // Windows Phone must come first because its UA also contains "Android"
    return "Windows Phone";
  } else if (/android/i.test(userAgent)) {
    return "Android";
  } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    return "iOS";
  } else {
    return "unknown";
  }
}

function unpack_props(props) {
  return props?.history?.location?.state || {};
}

const parsePhoneFromObj = (unformattedPhone, obj) => {
  let number;
  if (obj?.dialCode != null) {
    number = unformattedPhone.slice(obj.dialCode.length);
  }

  return {
    countryCode: obj?.dialCode || null,
    number: number.length > 0 ? number : null,
  };
};

/**
 * Message
 */

const message = (config) => {
  const { type, content, key, duration } = config;
  antdMessage[type]({
    content: content || "",
    key: key || "updatable",
    duration: duration || 5,
    style: {
      marginTop: getMobileOperatingSystem() == "iOS" ? 20 : 0,
    },
  });
};

/**
 * Ticket checking
 */

const isEventTicket = (eventId) => {
  return eventId == null || eventId == "" ? false : true;
};

const isVoucher = (discountType) => {
  return discountType == "" || discountType == null;
};

const isDiscount = (discountType) => {
  return ["price", "percentage", "other"].includes(discountType);
};

const isTicket_expired = (ticket) => {
  let expired = true;
  let today = formatTime("YYYY-MM-DD");

  if (isEventTicket(ticket.eventId)) {
    //event ticket
    if (isEventOngoing(ticket.event?.time?.start, ticket.event?.time?.end) == true) {
      expired = false;
    }
  } else {
    //non event ticket
    if (moment(today).isAfter(ticket.expiry) == false) {
      expired = false;
    }
  }
  return expired;
};

/**
 * Event
 */
const isEventOngoing = (start, end) => {
  let today = moment().format("YYYY-MM-DD");
  start = moment(start).format("YYYY-MM-DD");
  end = moment(end).format("YYYY-MM-DD");
  // console.log(moment(today).isSame(publishTime));
  // console.log(moment(today).isAfter(publishTime));
  return moment(today).isBefore(start) == false && moment(today).isBefore(end) == true;
};

/**
 * Get Ticket Request Status
 */
const ticket_request = {
  get_status: (record) => {
    if (moment().isAfter(record.expiry)) {
      return "Expired";
    }
    if (record.status == "Wait for approve") {
      return "Wait for approve";
    }
    if (record.status == "Approved") {
      if (record.update == null) {
        return "Approved";
      } else {
        return "Wait for approve";
      }
    }
    if (record.status == "Reject") {
      return "Reject";
    }
    if (record.status == "Cancelled") {
      return "Cancelled";
    }
    if (record.status == "Cancelled") {
      return "Cancelled";
    }
  },
  get_requset_type: (record) => {
    if (record.update == null) {
      return "issue";
    } else {
      return "update";
    }
  },
};

const getDisplayAddress = (address) => {
  let { street, city, province, postalCode, country } = address || {};

  let display = `${street ? street + "," : ""} ${city ? city + "," : ""} ${province ? province + "," : ""} ${
    postalCode ? postalCode + "," : ""
  } ${country ? country : ""}`;

  return display;
};

const diff = (o1, o2) => {
  let ans = fullDiff(o1, o2);
  return _.isEmpty(ans) ? null : ans;
};

const replaceStatusTypo = (data) => {
  return data.map((item) => {
    const updatedItem = { ...item };
    for (const key in updatedItem) {
      if (updatedItem.hasOwnProperty(key) && typeof updatedItem[key] === "string") {
        if (updatedItem[key] === "Sccuess") {
          updatedItem[key] = "Success";
        }
      }
    }
    return updatedItem;
  });
};

function random4Digit() {
  function shuffle(o) {
    for (var j, x, i = o.length; i; j = Math.floor(Math.random() * i), x = o[--i], o[i] = o[j], o[j] = x);
    return o;
  }
  return shuffle("0123456789".split("")).join("").substring(0, 4);
}

// Helper function to normalize query params
const normalizeQuery = (params) => {
  // Sort the query parameters alphabetically
  const sortedEntries = Object.entries(params).sort(([keyA], [keyB]) => keyA.localeCompare(keyB));
  const normalizedQueryString = new URLSearchParams(sortedEntries).toString();
  return normalizedQueryString;
};

const generateId = (letterLength, digitLength) => {
  const lettersOpts = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const digitsOpts = "0123456789";

  let id = "";

  // Generate random letters
  for (let i = 0; i < letterLength; i++) {
    id += lettersOpts.charAt(Math.floor(Math.random() * lettersOpts.length));
  }

  // Generate random digits
  for (let i = 0; i < digitLength; i++) {
    id += digitsOpts.charAt(Math.floor(Math.random() * digitsOpts.length));
  }

  return id;
};

const parseQueryToJSON = (queryString) => {
  // return Object.fromEntries(new URLSearchParams(queryString).entries());
  const params = new URLSearchParams(queryString);
  const result = {};

  for (const [key, value] of params) {
    if (result[key]) {
      // If key already exists, push the new value into an array
      result[key] = Array.isArray(result[key]) ? [...result[key], value] : [result[key], value];
    } else {
      // First occurrence of the key
      result[key] = value;
    }
  }

  return result;
};

// // Recursive helper function to deeply compare objects and return the diff
// const getObjectDiff = (original, updated) => {
//   const diff = {};

//   Object.keys(updated).forEach((key) => {
//     // If the value is an object, recursively compare
//     if (_.isObject(updated[key]) && !_.isArray(updated[key])) {
//       const nestedDiff = getObjectDiff(original[key] || {}, updated[key]);
//       if (!_.isEmpty(nestedDiff)) {
//         diff[key] = nestedDiff; // Only add non-empty diffs
//       }
//     } else if (!_.isEqual(updated[key], original[key])) {
//       // If the values are different (and not objects), add to diff
//       diff[key] = updated[key];
//     }
//   });

//   return diff;
// };

const getObjectDiff = (original, updated) => {
  const diff = {};

  // Handle cases where original or updated is undefined
  const safeOriginal = _.isObject(original) ? original : {};
  const safeUpdated = _.isObject(updated) ? updated : {};

  // Check for deleted fields
  Object.keys(safeOriginal).forEach((key) => {
    if (!_.has(safeUpdated, key)) {
      // If the key doesn't exist in updated, mark it as deleted
      diff[key] = undefined;
    }
  });

  // Compare fields in the updated object
  Object.keys(safeUpdated).forEach((key) => {
    // If the value is an object, recursively compare
    if (_.isObject(safeUpdated[key]) && !_.isArray(safeUpdated[key])) {
      const nestedDiff = getObjectDiff(safeOriginal[key], safeUpdated[key]);
      if (!_.isEmpty(nestedDiff)) {
        diff[key] = nestedDiff; // Only add non-empty diffs
      }
    } else if (!_.isEqual(safeUpdated[key], safeOriginal[key])) {
      // If the values are different (and not objects), add to diff
      diff[key] = safeUpdated[key];
    }
  });

  return diff;
};

const hasDiff = (original, data) => {
  return !_.isEqual(original, data);
};

const getBrandAndCompanyFromRequest = (request) => {
  let company, brand;

  if (request?.type === "new") {
    // For 'new' requests, use data from initialRequest if available
    // No need to get shop data from initialRequest since new shop request must have shop data already
    const initialInfo = request?.initialRequest?.info || {};
    company = initialInfo.company || request?.company || request?.info?.company;
    brand = initialInfo.brand || request?.brand || request?.info?.brand;
  } else if (request?.type === "update") {
    // For 'update' requests, directly use data from the request
    company = request?.company;
    brand = request?.brand;
  }

  return { brand, company };
};

const getProductFromRequest = (request) => {
  let product;

  if (request?.type === "new") {
    product = request?.product || request?.info?.product;
  } else if (request?.type === "update") {
    // For 'update' requests, directly use data from the request
    product = request?.product;
  }

  return { product };
};

const getMaxShopExpiry = (company) => {
  if (!company?.permission?.shopsExpiry || company.permission.shopsExpiry.length === 0) {
    return null; // Return null if there's no shop expiry data
  }

  // Extract the expiry dates and find the maximum one
  const maxExpiry = company.permission.shopsExpiry.reduce((max, shop) => {
    const expiryDate = new Date(shop.expiry);
    return expiryDate > max ? expiryDate : max;
  }, new Date(0)); // Start with the earliest possible date

  return maxExpiry;
};

const hashPassword = async (plainPassword) => {
  const saltRounds = 10; 
  const salt = await bcrypt.genSalt(saltRounds);
  const hash = await bcrypt.hash(plainPassword, salt);
  return hash;
};

const capToTwoDecimals = (num) => {
  if (typeof num !== "number" || isNaN(num)) return 0; // Handle invalid inputs
  return parseFloat(num.toFixed(2)); // Cap to 5 decimals
};

export default {
  getBookOptionList,
  displayReadId,
  sleep,
  getMobileOperatingSystem,
  unpack_props,
  parsePhoneFromObj,
  message,
  isEventTicket,
  isVoucher,
  isDiscount,
  isTicket_expired,
  isEventOngoing,
  ticket_request,
  getDisplayAddress,
  diff,
  replaceStatusTypo,
  random4Digit,
  normalizeQuery,
  generateId,
  parseQueryToJSON,
  getObjectDiff,
  hasDiff,
  getBrandAndCompanyFromRequest,
  getProductFromRequest,
  getMaxShopExpiry,
  hashPassword,
  capToTwoDecimals,
};
